import React from 'react';
import Reviews from '../../../assets/images/reviews.png';
import ReviewsCard from '../../../assets/images/reviews_home.png';
import useDesignUtils from '../../../hooks/useDesignUtils';
import { Box, Copy, VStack } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';

const GoogleReviews = () => {
  const { isMobile } = useDesignUtils();

  return (
    <SectionLayout
      backgroundColor="white"
      overflow="hidden"
      paddingY="xxxlarge"
    >
      <Box
        width="100%"
        maxWidth="1200px"
        paddingX="medium"
        margin="auto"
        marginY="xxxlarge"
      >
        <VStack space="xxlarge">
          <Box width={{ mobile: '100%', desktop: '80%' }}>
            <Copy
              tag="h2"
              fontWeight="bold"
              color="_darkGray"
              fontSize="midHeader"
            >
              Nuestra plataforma es la mejor puntuada y mencionada por la prensa
              y nuestros clientes
            </Copy>
          </Box>
          <Box
            borderRadius="medium"
            backgroundColor="primary"
            padding="xlarge"
            position="relative"
            height={{ mobile: '470px', desktop: '500px' }}
            width="100%"
            margin="auto"
          >
            <Copy
              color="_darkGray"
              fontSize="_newHomeTitle"
              fontWeight="semibold"
            >
              Google Reviews
            </Copy>
            <Box tag="img" src={Reviews} />
            <Box
              position="absolute"
              top={isMobile ? 'auto' : '-15px'}
              right="-20px"
              left={isMobile ? '-35px' : 'auto'}
            >
              <Box tag="img" src={ReviewsCard} />
            </Box>
          </Box>
        </VStack>
      </Box>
    </SectionLayout>
  );
};

export { GoogleReviews };
